import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import logo from "../assets/img/logom.png";
import navIcon1 from '../assets/img/logo_git.png';
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          {/* <MailchimpForm /> */}
          <Col style={{marginTop: "40px"}} size={12} sm={6}>
            <img src={logo} alt="Logo" id="logo_image"/>
          </Col>
          <Col style={{marginTop: "40px"}}  size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a href="https://github.com/deno832"><img src={navIcon1} alt="Icon" /></a>
              {/* <a href="https://media.tenor.com/EnL3md9eU1MAAAAC/yok-ghost.gif"><img src={navIcon2} alt="Icon" /></a> */}
              <a href="https://www.instagram.com/denizerenyildirim/"><img src={navIcon3} alt="Icon" /></a>
            </div>
            <h3 className="my-4" style={{color: "#7909e8", marginRight: "0px"}}>Deniz Eren YILDIRIM</h3>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
